import React from 'react'

export default function Calculator() {
    return (
        <div className='calculators'><div id='sgi' data-guid='992bb347-c05f-4ea6-aa25-aaa0352409e2'></div></div>
    )
}